import "./Style.scss";
import Header from "../components/Header";
import Footer from "../components/Footer";


function Career(){
    return(
        <div className="page">
            <Header active="career"/>

            <div className="pageBody">
                <div className="container">
                    <div className="row">

                        <div className="col-12">
                            <div className="pageHeading">
                                <h2>Careers</h2>
                            </div>

                            Some content here...
                        </div>

                    </div>
                </div>
            </div>
            
            <Footer/>
        </div>
    );
}

export default Career;